import { useCallback } from 'react';

export function useToast() {
  const showToast = useCallback(
    (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') => {
      const toastEl = document.getElementById('toast');
      const toastBody = document.getElementById('toastBody');
      if (!toastEl || !toastBody) return;

      toastBody.textContent = message;
      const icon = toastEl.querySelector('.toast-header i');
      if (icon) {
        const iconClasses: Record<string, string> = {
          success: 'fas fa-check-circle text-success me-2',
          error: 'fas fa-exclamation-circle text-danger me-2',
          warning: 'fas fa-exclamation-triangle text-warning me-2',
          info: 'fas fa-info-circle text-primary me-2',
        };
        icon.className = iconClasses[type] || iconClasses.info;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const bsToast = new (window as any).bootstrap.Toast(toastEl);
      bsToast.show();
    },
    []
  );

  return { showToast };
}